<template>
  <div class="bc-index-page">
    <!-- 顶栏：语言 + 菜单 -->
    <nav class="bc-top-nav" :class="{ 'bc-top-nav--in': isLoaded }">
      <div class="bc-top-nav__inner">
        <div class="bc-lang">
          <button
            type="button"
            class="bc-lang__btn"
            :class="{ 'bc-lang__btn--active': $getLocale() === 'en-US' }"
            @click="setLangEn"
          >
            EN
          </button>
          <button
            type="button"
            class="bc-lang__btn"
            :class="{ 'bc-lang__btn--active': $getLocale() === 'zh-CN' }"
            @click="setLangZh"
          >
            CN
          </button>
        </div>
        <button type="button" class="bc-menu-trigger" aria-label="menu" @click="menuOpen = true">
          <svg class="bc-menu-trigger__icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              d="M4 6h16M4 12h16M4 18h16"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </nav>

    <BcSlideMenu
      :visible.sync="menuOpen"
      :bg-image="img.bg"
      :items="menuItems"
      label-mode="i18n"
      @select="onMenuItem"
    />

    <!-- Hero -->
    <section class="bc-hero">
      <div class="bc-hero__bg">
        <img :src="img.bg" alt="" class="bc-hero__bg-img" />
      </div>
      <div class="bc-hero__logo" :class="{ 'bc-hero__logo--in': isLoaded }">
        <img :src="img.logo" alt="Logo" />
      </div>
      <BcHeroNotice :visible="isLoaded" />
      <div class="bc-hero__athlete" :class="{ 'bc-hero__athlete--in': isLoaded }">
        <img :src="img.pic1" alt="" />
      </div>
      <div class="bc-hero__title" :class="{ 'bc-hero__title--in': isLoaded }">
        <img :src="img.pic2" alt="2026 Trampoline World Championships" />
      </div>
    </section>

    <!-- About -->
    <section class="bc-about">
      <div class="bc-inner">
        <div class="bc-section-head bc-section-head--center">
          <div class="bc-section-head__water">{{ $T('年龄组关于赛事水印大标题') }}</div>
          <h2 class="bc-section-head__title">{{ $T('年龄组关于赛事章节标题') }}</h2>
        </div>
        <div class="bc-about__grid">
          <div class="bc-about__text">
            <h3>{{ $T('年龄组关于赛事小节标题') }}</h3>
            <p>
              {{ $T('年龄组关于赛事段落1') }}
            </p>
            <p>
              {{ $T('年龄组关于赛事段落2') }}
            </p>
            <p>
              {{ $T('年龄组关于赛事段落3') }}
            </p>
          </div>
          <div class="bc-about__img-wrap">
            <img :src="img.pic4" alt="" class="bc-about__img" />
          </div>
        </div>
        <div class="bc-countdown-wrap">
          <div class="bc-countdown">
            <div class="bc-countdown__cell">
              <div class="bc-countdown__num">{{ pad2(timeLeft.days) }}</div>
              <div class="bc-countdown__lbl">{{ $T('官网倒计时天') }}</div>
            </div>
            <div class="bc-countdown__sep">:</div>
            <div class="bc-countdown__cell">
              <div class="bc-countdown__num">{{ pad2(timeLeft.hours) }}</div>
              <div class="bc-countdown__lbl">{{ $T('官网倒计时时') }}</div>
            </div>
            <div class="bc-countdown__sep">:</div>
            <div class="bc-countdown__cell">
              <div class="bc-countdown__num">{{ pad2(timeLeft.minutes) }}</div>
              <div class="bc-countdown__lbl">{{ $T('官网倒计时分') }}</div>
            </div>
            <div class="bc-countdown__sep">:</div>
            <div class="bc-countdown__cell">
              <div class="bc-countdown__num">{{ pad2(timeLeft.seconds) }}</div>
              <div class="bc-countdown__lbl">{{ $T('官网倒计时秒') }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- News -->
    <section class="bc-news">
      <div class="bc-inner">
        <div class="bc-section-head">
          <div class="bc-section-head__water bc-section-head__water--left">{{ $T('最新新闻水印') }}</div>
          <h2 class="bc-section-head__title">{{ $T('最新新闻标题') }}</h2>
        </div>
        <div class="bc-news__grid">
          <article
            v-for="(card, idx) in newsCards"
            :key="idx"
            class="bc-news-card"
            @click="showComingSoon"
          >
            <div class="bc-news-card__pic">
              <img :src="card.img" alt="" />
              <div class="bc-news-card__date">{{ $T(card.dateKey) }}</div>
            </div>
            <div class="bc-news-card__body">
              <h3>{{ $T(card.titleKey) }}</h3>
              <p>{{ $T(card.descKey) }}</p>
              <button
                type="button"
                class="bc-news-card__btn"
                :style="{ background: card.btnColor }"
                @click.stop="showComingSoon"
              >
                {{ $T('新闻阅读更多') }} <span>→</span>
              </button>
            </div>
          </article>
        </div>
      </div>
    </section>

    <!-- Nanjing -->
    <section class="bc-nj">
      <div class="bc-inner">
        <p class="bc-nj__eyebrow">{{ $T('南京区块眉题') }}</p>
        <h2 class="bc-nj__title">{{ $T('南京区块主标题') }}</h2>
        <div class="bc-nj__row">
          <div class="bc-nj__text">
            <h3>{{ $T('南京区块小节标题') }}</h3>
            <p>
              {{ $T('南京区块段落1') }}
            </p>
            <p>
              {{ $T('南京区块段落2') }}
            </p>
          </div>
          <div class="bc-nj__tall">
            <img :src="img.nj1" alt="" />
          </div>
        </div>
        <div class="bc-nj__tiles">
          <div class="bc-nj__tile"><img :src="img.nj2" alt="" /></div>
          <div class="bc-nj__tile"><img :src="img.nj3" alt="" /></div>
          <div class="bc-nj__tile"><img :src="img.nj4" alt="" /></div>
        </div>
      </div>
    </section>

    <!-- Partners -->
    <section class="bc-partners">
      <div class="bc-inner">
        <div class="bc-section-head bc-section-head--center">
          <div class="bc-section-head__water">{{ $T('合作伙伴水印') }}</div>
          <h2 class="bc-section-head__title bc-section-head__title--upper">{{ $T('合作伙伴标题') }}</h2>
        </div>
        <div class="bc-partners__grid">
          <div class="bc-partners__cell"><img :src="img.plogo1" alt="" /></div>
          <div class="bc-partners__cell"><img :src="img.plogo2" alt="" /></div>
          <div class="bc-partners__cell"><img :src="img.plogo3" alt="" /></div>
        </div>
      </div>
    </section>

    <footer class="bc-footer">
      <div class="bc-footer__deco" aria-hidden="true">
        <svg class="bc-footer__wave" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path
            fill="rgba(43,123,191,0.3)"
            d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,112C672,96,768,96,864,112C960,128,1056,160,1152,160C1248,160,1344,128,1392,112L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          />
        </svg>
        <div class="bc-footer__circle bc-footer__circle--1"></div>
        <div class="bc-footer__circle bc-footer__circle--2"></div>
        <div class="bc-footer__circle bc-footer__circle--3"></div>
        <div class="bc-footer__bars">
          <div v-for="i in 12" :key="'fb-' + i" class="bc-footer__bar" :style="{ height: ((i - 1) % 3 + 1) * 20 + 'px' }"></div>
        </div>
      </div>
      <div class="bc-inner bc-footer__main">
        <div class="bc-footer__left">
          <img :src="img.logo" alt="" class="bc-footer__logo" />
          <p class="bc-footer__copy">{{ $T('年龄组官网页脚版权') }}</p>
          <p class="bc-footer__sub">{{ $T('年龄组官网页脚副标题') }}</p>
        </div>
        <div class="bc-footer__right">
          <h3>{{ $T('官网页脚敬请期待') }}</h3>
          <div class="bc-footer__social">
            <a href="#" class="bc-footer__soc" aria-label="Facebook" @click.prevent="footerComingSoon">
              <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path
                  d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
                />
              </svg>
            </a>
            <a href="#" class="bc-footer__soc" aria-label="Instagram" @click.prevent="footerComingSoon">
              <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path
                  d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                />
              </svg>
            </a>
            <a href="#" class="bc-footer__soc" aria-label="YouTube" @click.prevent="footerComingSoon">
              <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path
                  d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
                />
              </svg>
            </a>
            <a href="#" class="bc-footer__soc" aria-label="X" @click.prevent="footerComingSoon">
              <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
                <path
                  d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div class="bc-inner bc-footer__links">
        <button type="button" @click="footerComingSoon">{{ $T('官网页脚隐私') }}</button>
        <span>|</span>
        <button type="button" @click="footerComingSoon">{{ $T('官网页脚条款') }}</button>
        <span>|</span>
        <button type="button" @click="footerComingSoon">{{ $T('官网页脚联系') }}</button>
        <span>|</span>
        <button type="button" @click="footerComingSoon">{{ $T('官网页脚媒体') }}</button>
      </div>
    </footer>

  </div>
</template>

<script>
import BcSlideMenu from './BcSlideMenu.vue';
import BcHeroNotice from './BcHeroNotice.vue';
import { BC_SLIDE_MENU_BG, getBcIndexLogoUrl, getBcSlideMenuItems, navigateSlideMenuItem } from './bcSlideMenuConfig';

const IMG = 'https://bc-api.ccachina.net/public/images';

export default {
  name: 'IndexPc',
  components: {
    BcSlideMenu,
    BcHeroNotice,
  },
  data() {
    return {
      menuOpen: false,
      isLoaded: false,
      countdownTimer: null,
      rafId: null,
      timeLeft: {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },
      img: {
        bg: BC_SLIDE_MENU_BG,
        pic1: `${IMG}/bc-index-pic1-age.png`,
        pic2: `${IMG}/bc-index-pic2-age.png`,
        logo: getBcIndexLogoUrl(2),
        pic4: `${IMG}/bc-index-pic4.jpg`,
        news1: `${IMG}/bc-index-news1.jpg`,
        news2: `${IMG}/bc-index-news2.jpg`,
        news3: `${IMG}/bc-index-news3.jpg`,
        nj1: `${IMG}/bc-index-nj1.jpg`,
        nj2: `${IMG}/bc-index-nj2.jpg`,
        nj3: `${IMG}/bc-index-nj3.jpg`,
        nj4: `${IMG}/bc-index-nj4.jpg`,
        plogo1: `${IMG}/bc-index-p-logo1.png`,
        plogo2: `${IMG}/bc-index-p-logo2.png`,
        plogo3: `${IMG}/bc-index-p-logo3.png`,
      },
      newsCards: [
        {
          img: `${IMG}/bc-index-news1.jpg`,
          dateKey: '官网新闻1日期',
          titleKey: '官网新闻1标题',
          descKey: '官网新闻1摘要',
          btnColor: '#4A9FD8',
        },
        {
          img: `${IMG}/bc-index-news2.jpg`,
          dateKey: '官网新闻2日期',
          titleKey: '官网新闻2标题',
          descKey: '官网新闻2摘要',
          btnColor: '#E85D3B',
        },
        {
          img: `${IMG}/bc-index-news3.jpg`,
          dateKey: '官网新闻3日期',
          titleKey: '官网新闻3标题',
          descKey: '官网新闻3摘要',
          btnColor: '#C2408B',
        },
      ],
    };
  },
  computed: {
    menuItems() {
      return getBcSlideMenuItems(2);
    },
  },
  created() {
    localStorage.setItem('project_type', '2');
  },
  mounted() {
    document.title = this.$T('年龄组官网页面标题');
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', this.$T('年龄组官网页面描述'));
    }
    this.rafId = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.isLoaded = true;
      });
    });
    this.tickCountdown();
    this.countdownTimer = setInterval(this.tickCountdown, 1000);
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
    }
  },
  methods: {
    pad2(n) {
      const v = Math.max(0, Math.floor(Number(n) || 0));
      return String(v).padStart(2, '0');
    },
    tickCountdown() {
      const target = new Date('2026-11-12T00:00:00').getTime();
      const diff = target - Date.now();
      if (diff <= 0) {
        this.timeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };
        return;
      }
      this.timeLeft = {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((diff % (1000 * 60)) / 1000),
      };
    },
    showComingSoon() {
      this.$message.info(this.$T('敬请期待'));
    },
    setLangEn() {
      if (typeof this.$setLocale === 'function') {
        this.$setLocale('en-US');
      }
      window.location.reload();
    },
    setLangZh() {
      if (typeof this.$setLocale === 'function') {
        this.$setLocale('zh-CN');
      }
      window.location.reload();
    },
    onMenuItem(item) {
      if (navigateSlideMenuItem(this.$router, item)) {
        return;
      }
      this.showComingSoon();
    },
    footerComingSoon() {
      this.showComingSoon();
    },
  },
};
</script>

<style lang="scss" scoped>
.bc-index-page {
  min-height: 100vh;
  overflow-x: hidden;
  background: #1a1f3a;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  color: #1e2842;
}

.bc-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding-left: 32px;
  padding-right: 32px;
}

/* Top nav */
.bc-top-nav {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 50;
  padding: 32px;
  opacity: 0;
  transform: translateX(24px);
  transition: opacity 1s ease, transform 1s ease;
}
.bc-top-nav--in {
  opacity: 1;
  transform: translateX(0);
}
.bc-top-nav__inner {
  display: flex;
  align-items: center;
  gap: 24px;
}
.bc-lang {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
}
.bc-lang__btn {
  border: none;
  background: transparent;
  color: #fff;
  padding: 6px 16px;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  transition: background 0.2s, color 0.2s;
}
.bc-lang__btn:hover {
  color: #e5e7eb;
}
.bc-lang__btn--active {
  background: #fff;
  color: #1a1f3a;
}
.bc-menu-trigger {
  border: none;
  cursor: pointer;
  padding: 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  color: #fff;
}
.bc-menu-trigger:hover {
  background: rgba(255, 255, 255, 0.2);
}
.bc-menu-trigger__icon {
  width: 24px;
  height: 24px;
  display: block;
  flex-shrink: 0;
}

/* Hero */
.bc-hero {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
}
.bc-hero__bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}
.bc-hero__bg-img {
  width: 100%;
  height: auto;
  min-height: 100%;
  object-fit: cover;
  display: block;
}
.bc-hero__logo {
  position: absolute;
  top: 5%;
  left: 5%;
  z-index: 30;
  width: 42vw;
  max-width: 300px;
  opacity: 0;
  transform: translateX(-24px);
  transition: opacity 1s ease 0.15s, transform 1s ease 0.15s;
}
.bc-hero__logo--in {
  opacity: 1;
  transform: translateX(0);
}
.bc-hero__logo img {
  width: 100%;
  height: auto;
  display: block;
}
.bc-hero__athlete {
  position: absolute;
  top: 40%;
  left: 50%;
  z-index: 20;
  opacity: 0;
  transform: translate(-50%, calc(-50% + 5rem));
  transition: opacity 1s ease 0.3s, transform 1s ease 0.3s;
}
.bc-hero__athlete--in {
  opacity: 1;
  transform: translate(-50%, -50%);
}
.bc-hero__athlete img {
  max-height: 38vh;
  width: auto;
  height: auto;
  display: block;
}
.bc-hero__title {
  position: absolute;
  bottom: 100px;
  left: 50%;
  z-index: 20;
  width: 60%;
  max-width: 900px;
  opacity: 0;
  transform: translate(-50%, 5rem);
  transition: opacity 1s ease 0.5s, transform 1s ease 0.5s;
}
.bc-hero__title--in {
  opacity: 1;
  transform: translate(-50%, 0);
}
.bc-hero__title img {
  width: 100%;
  height: auto;
  display: block;
}

@media (max-width: 768px) {
  .bc-hero__athlete {
    top: 54%;
  }
  .bc-hero__athlete img {
    max-height: 28vh;
  }
  .bc-hero__title {
    bottom: 56px;
    width: 88%;
  }
  .bc-top-nav {
    padding: 16px;
  }
}

/* Section titles */
.bc-section-head {
  position: relative;
  margin-bottom: 64px;
}
.bc-section-head--center {
  text-align: center;
}
.bc-section-head__water {
  position: absolute;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  font-size: unquote('clamp(36px, 6vw, 72px)');
  font-weight: 900;
  color: rgba(209, 213, 219, 0.65);
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
}
.bc-section-head__water--left {
  left: 0;
  transform: none;
}
.bc-section-head__title {
  position: relative;
  z-index: 2;
  font-size: unquote('clamp(36px, 5vw, 56px)');
  font-weight: 900;
  color: #1e2842;
  margin: 0;
}
.bc-section-head__title--upper {
  letter-spacing: 0.05em;
}

/* About */
.bc-about {
  background: #fff;
  padding: 96px 0;
}
.bc-about__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}
@media (max-width: 1024px) {
  .bc-about__grid {
    grid-template-columns: 1fr;
  }
}
.bc-about__text h3 {
  font-size: 28px;
  font-weight: 600;
  color: #1a1f3a;
  margin: 0 0 16px;
}
.bc-about__text p {
  font-size: 18px;
  line-height: 1.7;
  color: #374151;
  margin: 0 0 16px;
}
.bc-about__img {
  width: 100%;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  display: block;
}
.bc-countdown-wrap {
  margin-top: 80px;
  display: flex;
  justify-content: center;
}
.bc-countdown {
  display: flex;
  align-items: flex-end;
  gap: 32px;
  background: #000;
  border-radius: 24px;
  padding: 48px 56px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}
.bc-countdown__cell {
  text-align: center;
}
.bc-countdown__num {
  font-size: unquote('clamp(40px, 8vw, 72px)');
  font-weight: 700;
  color: #fff;
  line-height: 1;
  margin-bottom: 8px;
}
.bc-countdown__lbl {
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #9ca3af;
}
.bc-countdown__sep {
  font-size: 48px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.45);
  padding-bottom: 8px;
}
@media (max-width: 640px) {
  .bc-countdown {
    flex-wrap: wrap;
    justify-content: center;
    padding: 32px 24px;
    gap: 16px;
  }
  .bc-countdown__sep {
    display: none;
  }
}

/* News */
.bc-news {
  background: linear-gradient(to bottom, #f9fafb, #fff);
  padding: 96px 0;
}
.bc-news__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
}
@media (max-width: 1024px) {
  .bc-news__grid {
    grid-template-columns: 1fr;
  }
}
.bc-news-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: box-shadow 0.3s;
}
.bc-news-card:hover {
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.14);
}
.bc-news-card__pic {
  height: 256px;
  overflow: hidden;
  position: relative;
}
.bc-news-card__pic img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.bc-news-card__date {
  position: absolute;
  bottom: 16px;
  left: 16px;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(6px);
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
}
.bc-news-card__body {
  padding: 24px;
}
.bc-news-card__body h3 {
  font-size: 22px;
  font-weight: 700;
  color: #1a1f3a;
  margin: 0 0 16px;
  line-height: 1.35;
}
.bc-news-card__body p {
  color: #4b5563;
  line-height: 1.65;
  margin: 0 0 16px;
  font-size: 15px;
}
.bc-news-card__btn {
  border: none;
  color: #fff;
  padding: 12px 22px;
  border-radius: 999px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: filter 0.2s;
}
.bc-news-card__btn:hover {
  filter: brightness(1.08);
}

/* Nanjing */
.bc-nj {
  background: #3f7e9e;
  padding: 80px 0;
  color: #fff;
}
.bc-nj__eyebrow {
  letter-spacing: 0.3em;
  text-transform: uppercase;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 8px;
}
.bc-nj__title {
  font-size: unquote('clamp(32px, 4vw, 48px)');
  font-weight: 900;
  margin: 0 0 48px;
}
.bc-nj__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
  background: #fff;
  margin-bottom: 2px;
}
@media (max-width: 1024px) {
  .bc-nj__row {
    grid-template-columns: 1fr;
  }
}
.bc-nj__text {
  background: #3f7e9e;
  padding: 24px 32px 32px 0;
}
.bc-nj__text h3 {
  font-size: 26px;
  font-weight: 600;
  margin: 0 0 16px;
}
.bc-nj__text p {
  font-size: 15px;
  line-height: 1.75;
  color: rgba(255, 255, 255, 0.92);
  margin: 0 0 12px;
}
.bc-nj__tall {
  height: 480px;
  overflow: hidden;
  background: #3f7e9e;
}
.bc-nj__tall img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.35s ease;
}
.bc-nj__tall:hover img {
  transform: scale(1.08);
}
.bc-nj__tiles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2px;
  background: #fff;
  padding-top: 2px;
}
@media (max-width: 768px) {
  .bc-nj__tiles {
    grid-template-columns: 1fr;
  }
}
.bc-nj__tile {
  height: 288px;
  overflow: hidden;
  background: #3f7e9e;
}
.bc-nj__tile img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.35s ease;
}
.bc-nj__tile:hover img {
  transform: scale(1.08);
}

/* Partners */
.bc-partners {
  background: #f9fafb;
  padding: 80px 0;
}
.bc-partners__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 64px;
  align-items: center;
}
@media (max-width: 768px) {
  .bc-partners__grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }
}
.bc-partners__cell {
  display: flex;
  justify-content: center;
  align-items: center;
}
.bc-partners__cell img {
  max-width: 100%;
  height: auto;
}

.bc-footer {
  position: relative;
  background: linear-gradient(135deg, #2b7bbf 0%, #5fb87d 55%, #ffd93d 100%);
  padding: 64px 0 40px;
  overflow: hidden;
}
.bc-footer__deco {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0.2;
  pointer-events: none;
}
.bc-footer__wave {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 128px;
}
.bc-footer__circle {
  position: absolute;
  border-radius: 50%;
}
.bc-footer__circle--1 {
  top: 80px;
  right: 20%;
  width: 96px;
  height: 96px;
  border: 4px solid rgba(255, 217, 61, 0.4);
}
.bc-footer__circle--2 {
  top: 128px;
  right: 15%;
  width: 64px;
  height: 64px;
  background: rgba(95, 184, 125, 0.45);
}
.bc-footer__circle--3 {
  bottom: 80px;
  left: 10%;
  width: 80px;
  height: 80px;
  border: 4px solid rgba(43, 123, 191, 0.4);
}
.bc-footer__bars {
  position: absolute;
  top: 64px;
  right: 30%;
  display: flex;
  gap: 4px;
}
.bc-footer__bar {
  width: 4px;
  background: rgba(255, 217, 61, 0.35);
}
.bc-footer__main {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: start;
  margin-bottom: 32px;
}
@media (max-width: 768px) {
  .bc-footer__main {
    grid-template-columns: 1fr;
  }
  .bc-footer__right {
    align-items: flex-start !important;
  }
}
.bc-footer__logo {
  height: 64px;
  width: auto;
}
.bc-footer__copy,
.bc-footer__sub {
  color: rgba(255, 255, 255, 0.92);
  font-size: 14px;
  margin: 8px 0 0;
}
.bc-footer__right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}
.bc-footer__right h3 {
  margin: 0;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
}
.bc-footer__social {
  display: flex;
  gap: 12px;
}
.bc-footer__soc {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transition: background 0.2s;
}
.bc-footer__soc:hover {
  background: rgba(255, 255, 255, 0.32);
}
.bc-footer__links {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px 20px;
  padding-top: 32px;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
}
.bc-footer__links button {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0;
}
.bc-footer__links button:hover {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// IndexPcAge.vue?75a11ef0